var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

// src/init.ts
import { subscribe } from "valtio/vanilla";

// src/log.ts
var LOG_PREFIX = "[telemetry]";
function log(...data) {
  if (options.logging) {
    console.log(LOG_PREFIX, ...data);
  }
}
function warn(...data) {
  if (options.logging) {
    console.warn(LOG_PREFIX, ...data);
  }
}

// src/device.ts
import Cookies from "js-cookie";

// src/utils.ts
var lut = Array(256).fill(void 0).map((_, index) => {
  return (index < 16 ? "0" : "") + index.toString(16);
});
var generateUuidV4 = () => {
  const d0 = Math.random() * 4294967295 | 0;
  const d1 = Math.random() * 4294967295 | 0;
  const d2 = Math.random() * 4294967295 | 0;
  const d3 = Math.random() * 4294967295 | 0;
  return lut[d0 & 255] + lut[d0 >> 8 & 255] + lut[d0 >> 16 & 255] + lut[d0 >> 24 & 255] + "-" + lut[d1 & 255] + lut[d1 >> 8 & 255] + "-" + lut[d1 >> 16 & 15 | 64] + lut[d1 >> 24 & 255] + "-" + lut[d2 & 63 | 128] + lut[d2 >> 8 & 255] + "-" + lut[d2 >> 16 & 255] + lut[d2 >> 24 & 255] + lut[d3 & 255] + lut[d3 >> 8 & 255] + lut[d3 >> 16 & 255] + lut[d3 >> 24 & 255];
};

// src/device.ts
var DEVICE_COOKIE = "telemetryDeviceId";
var IN_10_YEARS = 365 * 10;
function getDeviceIdFromCookie() {
  const deviceId = Cookies.get(DEVICE_COOKIE);
  if (!deviceId) {
    const deviceId2 = generateUuidV4();
    Cookies.set(DEVICE_COOKIE, deviceId2, { expires: IN_10_YEARS, sameSite: "Lax" });
    return deviceId2;
  }
  return deviceId;
}
function getDeviceId() {
  if (options.getDeviceId) {
    const deviceId = options.getDeviceId();
    if (!deviceId) {
      warn(`getDeviceId() returned falsy value, using "${DEVICE_COOKIE}" device cookie instead`);
      return getDeviceIdFromCookie();
    }
    return deviceId;
  }
  return getDeviceIdFromCookie();
}

// src/session.ts
import Cookies2 from "js-cookie";

// src/state.ts
import { proxy } from "valtio/vanilla";
var state = proxy({
  events: []
});

// src/event.ts
function addEvent(init) {
  if (options.disabled)
    return;
  const timestamp = Date.now();
  const event = __spreadProps(__spreadValues({}, init), { event_uid: generateUuidV4(), timestamp });
  state.events.push(event);
  log("Event", event);
  refreshSession();
}
function addViewEvent(view, duration_ms, attributes) {
  addEvent({ log_type: "view", view, duration_ms, attributes });
}
function addDataEvent(view, eventName, attributes) {
  addEvent({ log_type: "data", view, event_name: eventName, attributes });
}
function addErrorEvent(view, eventName, attributes) {
  addEvent({ log_type: "error", view, event_name: eventName, attributes });
}
function addInteractionEvent(view, eventName, attributes) {
  addEvent({ log_type: "interaction", view, event_name: eventName, attributes });
}
function addSessionEvent(eventName, attributes) {
  addEvent({ log_type: "session", event_name: eventName, attributes });
}

// src/session.ts
var SESSION_COOKIE = "telemetrySessionId";
var IN_30_MINUTES = 1 / 48;
function getSessionId() {
  if (options.getSessionId) {
    return options.getSessionId();
  }
  return Cookies2.get(SESSION_COOKIE);
}
function startNewSession() {
  if (options.startNewSession) {
    options.startNewSession();
    if (options.getSessionId && options.getSessionId()) {
      addSessionEvent("start");
    } else {
      warn("getSessionId() returned falsy value, please check the return value of getSessionId in initTelemetry");
    }
    return;
  }
  Cookies2.set(SESSION_COOKIE, generateUuidV4(), { expires: IN_30_MINUTES, sameSite: "Lax" });
  if (getSessionId()) {
    addSessionEvent("start");
  }
}
function initSession() {
  const sessionId = getSessionId();
  if (!sessionId) {
    startNewSession();
  }
}
function refreshSession() {
  const sessionId = getSessionId();
  if (sessionId) {
    if (options.refreshSession) {
      options.refreshSession();
    } else {
      Cookies2.set(SESSION_COOKIE, sessionId, { expires: IN_30_MINUTES, sameSite: "Lax" });
    }
  } else {
    startNewSession();
  }
}
function deleteSession() {
  var _a, _b;
  (_b = (_a = options).removeSession) == null ? void 0 : _b.call(_a);
  Cookies2.remove(SESSION_COOKIE);
}

// src/send.ts
function sendData() {
  if (options.hasUserConsent === false)
    return;
  if (state.events.length === 0)
    return;
  const data = getData();
  log("Send", data);
  if (options.endpoint) {
    fetch(options.endpoint, {
      method: "POST",
      headers: __spreadValues({
        "Content-Type": "application/json"
      }, options.requestHeaders),
      body: JSON.stringify(data),
      keepalive: true
    }).catch(() => {
    });
  } else {
    warn("No endpoint defined");
  }
  state.events = [];
}
function getData() {
  var _a;
  const deviceId = getDeviceId();
  const { language, userAgent } = window.navigator;
  return __spreadValues({
    application_version: options.appVersion,
    application_timestamp: (_a = options.appTimestamp) == null ? void 0 : _a.getTime(),
    browser_fingerprint: fingerprint,
    device_id: deviceId,
    device_locale: language,
    device_model: userAgent.split("(")[1].split(")")[0],
    device_type: "web",
    event_bundle_id: generateUuidV4(),
    events: state.events.map((event) => {
      const { event_uid, timestamp, duration_ms, log_type, view, event_name, attributes } = event;
      return {
        event_uid,
        timestamp,
        duration_ms,
        log_type,
        view,
        event_name,
        attributes
      };
    }),
    screen_size: `${window.screen.width}x${window.screen.height}`,
    session_id: getSessionId(),
    standalone: window.matchMedia("(display-mode: standalone)").matches,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    upload_timestamp: Date.now(),
    user_agent: userAgent,
    user_id: state.userId,
    visitor_id: deviceId
  }, state.metadata);
}

// src/init.ts
import Fingerprint from "@fingerprintjs/fingerprintjs";
var options = {
  batchSize: 20,
  sendInterval: 3e4,
  logging: false,
  disabled: false
};
var fingerprint;
async function initTelemetry(init = {}) {
  options = __spreadValues(__spreadValues({}, options), init);
  if (options.disabled) {
    log("Disabled", options);
    return;
  }
  log("Init", options);
  initSession();
  await initFingerprint();
  const batchUnsubscribe = initBatchSubscribe();
  const removeUnloadListener = initUnloadListener();
  const removeVisibilityListener = initVisibilityListener();
  const removeSendInterval = initSendInterval();
  return () => {
    sendData();
    deleteSession();
    batchUnsubscribe();
    removeUnloadListener();
    removeVisibilityListener();
    removeSendInterval();
  };
}
function setHasUserConsent(hasUserConsent) {
  options.hasUserConsent = hasUserConsent;
  log("hasUserConsent", hasUserConsent);
}
async function initFingerprint() {
  const fp = await Fingerprint.load();
  const { visitorId } = await fp.get();
  fingerprint = visitorId;
}
function initBatchSubscribe() {
  return subscribe(state, () => {
    if (state.events.length >= options.batchSize) {
      sendData();
    }
  });
}
function initUnloadListener() {
  window.addEventListener("beforeunload", sendData);
  return () => window.removeEventListener("beforeunload", sendData);
}
function initVisibilityListener() {
  const logVisibility = () => {
    if (document.visibilityState === "hidden") {
      addSessionEvent("background");
      sendData();
    } else if (document.visibilityState === "visible") {
      addSessionEvent("foreground");
    }
  };
  document.addEventListener("visibilitychange", logVisibility);
  return () => {
    document.removeEventListener("visibilitychange", logVisibility);
  };
}
function initSendInterval() {
  let intervalId;
  if (options.sendInterval) {
    intervalId = setInterval(sendData, options.sendInterval);
  }
  return () => {
    clearInterval(intervalId);
  };
}

// src/user.ts
function telemetryLogin(userId) {
  if (options.disabled)
    return;
  log("Login", { userId });
  state.userId = userId;
}
function telemetryLogout() {
  if (options.disabled)
    return;
  log("Logout");
  sendData();
  state.userId = void 0;
  deleteSession();
}

// src/metadata.ts
function setMetadata(data) {
  sendData();
  log("setMetadata", data);
  state.metadata = data;
}
function getMetadata() {
  log("getMetadata", state.metadata);
  return state.metadata;
}
export {
  addDataEvent,
  addErrorEvent,
  addEvent,
  addInteractionEvent,
  addViewEvent,
  getMetadata,
  initTelemetry,
  sendData,
  setHasUserConsent,
  setMetadata,
  telemetryLogin,
  telemetryLogout
};
/**
 * Fast UUID generator, RFC4122 version 4 compliant.
 * @author Jeff Ward (jcward.com).
 * @license MIT license
 * @link http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
 **/
//# sourceMappingURL=index.mjs.map